/* BrightRest IL theme.js */
(function () {
  'use strict';
  var T = window.theme || {};
  var root = (T.rootUrl || '/').replace(/\/$/, '');

  /* Always "₪1,234.50" – the shop format ("{{amount}} NIS") breaks in RTL */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '₪' + v;
  }
  function moneyTag(cents, tag) { tag = tag || 'span'; return '<' + tag + ' class="money">' + money(cents) + '</' + tag + '>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function postJSON(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6"/></svg>';

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-open]');
    if (t) { var n = $('#MobileNav'); n.classList.add('is-open'); n.setAttribute('aria-hidden', 'false'); var f = n.querySelector('a,button'); f && f.focus(); }
    if (e.target.closest('[data-menu-close]')) { var m = $('#MobileNav'); m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
  });

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('.gallery__slides', g);
    var thumbs = $$('.gallery__thumb', g);
    var slides = $$('.gallery__slide', g);
    function idx() { return Math.round(Math.abs(track.scrollLeft) / track.clientWidth); }
    function go(i) {
      i = (i + slides.length) % slides.length;
      var dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollTo({ left: dir * i * track.clientWidth, behavior: 'smooth' });
    }
    function mark() { var i = idx(); thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = $('.gallery__arrow--prev', g), n = $('.gallery__arrow--next', g);
    p && p.addEventListener('click', function () { go(idx() - 1); });
    n && n.addEventListener('click', function () { go(idx() + 1); });
  });

  /* ---------- Bundle selector ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var idInput = $('input[name="id"]', form);
    var sticky = $('[data-sticky-atc]');
    var stockLine = $('[data-stock-line]');
    function sync() {
      var r = $('input[name="bundle"]:checked', form);
      if (!r) return;
      idInput.value = r.value;
      var now = r.getAttribute('data-price'), was = r.getAttribute('data-compare');
      $$('[data-price-now]').forEach(function (el) { el.textContent = money(+now); });
      $$('[data-price-was]').forEach(function (el) { el.textContent = was > 0 ? money(+was) : ''; });
      $$('[data-price-badge]').forEach(function (el) { var pct = was > 0 ? Math.round((1 - now / was) * 100) : 0; el.textContent = pct > 0 ? 'חיסכון של ' + pct + '%' : ''; el.hidden = pct <= 0; });
      $$('[data-sticky-label]').forEach(function (el) { el.textContent = r.getAttribute('data-label'); });
      if (stockLine) {
        var q = +(r.getAttribute('data-stock') || 0);
        var txt = $('[data-stock-text]', stockLine);
        txt.textContent = q > 0 ? (stockLine.getAttribute('data-low') || '').replace('[qty]', q) : stockLine.getAttribute('data-default');
        stockLine.classList.toggle('stock--low', q > 0);
      }
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'bundle') sync(); });
    sync();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type="submit"]', form);
      btn.disabled = true;
      var items = [{ id: +idInput.value, quantity: 1 }];
      $$('input[name="addon"]:checked', form).forEach(function (a) { items.push({ id: +a.value, quantity: 1 }); });
      postJSON('/cart/add.js', { items: items })
        .then(function () { $$('input[name="addon"]', form).forEach(function (a) { a.checked = false; }); return openCart(); })
        .catch(function (err) { alertMsg(form, (err && (err.description || err.message)) || 'אירעה שגיאה, נסו שוב'); })
        .finally(function () { btn.disabled = false; });
    });

    if (sticky) {
      var target = $('[data-atc-anchor]', form) || form;
      var io = new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); });
      io.observe(target);
      var sb = $('button', sticky);
      sb && sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : $('[type="submit"]', form).click(); });
    }
  });

  function alertMsg(form, msg) {
    var box = $('[data-form-error]', form);
    if (!box) return;
    box.textContent = msg; box.hidden = false;
    setTimeout(function () { box.hidden = true; }, 6000);
  }

  /* ---------- Cart (drawer + cart page share the same panel) ---------- */
  var drawer = $('#CartDrawer');
  var panels = $$('[data-cart-panel]');
  var drawerHasPanel = !!(drawer && $('[data-cart-panel]', drawer));
  var P0 = panels[0];
  var PV = P0 ? (P0.getAttribute('data-protection-variant') || '') : '';
  var PDEF = P0 ? P0.getAttribute('data-protection-default') === 'true' : false;
  var lastFocus = null;
  var syncing = false;
  var pending = Promise.resolve();
  var compareAt = {};
  var loadedHandles = {};

  function protectionWanted() {
    var s = null;
    try { s = window.localStorage.getItem('br_ship_protect'); } catch (e) {}
    if (s === 'on') return true;
    if (s === 'off') return false;
    return PDEF;
  }
  function setProtectionPref(on) { try { window.localStorage.setItem('br_ship_protect', on ? 'on' : 'off'); } catch (e) {} }
  function isProtection(it) { return !!PV && String(it.variant_id) === PV; }

  function fetchCart() { return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function reconcile(cart) {
    if (!PV || syncing) return Promise.resolve(cart);
    var others = cart.items.filter(function (it) { return !isProtection(it); });
    var have = cart.items.filter(isProtection).reduce(function (s, it) { return s + it.quantity; }, 0);
    var target = others.length > 0 && protectionWanted() ? 1 : 0;
    if (have === target) return Promise.resolve(cart);
    syncing = true;
    var updates = {}; updates[PV] = target;
    return postJSON('/cart/update.js', { updates: updates })
      .catch(function () { return cart; })
      .finally(function () { syncing = false; });
  }

  function loadCompare(cart) {
    var handles = [];
    cart.items.forEach(function (it) { if (!isProtection(it) && it.handle && !loadedHandles[it.handle] && handles.indexOf(it.handle) < 0) handles.push(it.handle); });
    if (!handles.length) return Promise.resolve(cart);
    return Promise.all(handles.map(function (h) {
      return fetch(root + '/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { (p.variants || []).forEach(function (v) { compareAt[String(v.id)] = v.compare_at_price || 0; }); })
        .catch(function () {})
        .then(function () { loadedHandles[h] = true; });
    })).then(function () { return cart; });
  }
  function refresh(p) {
    pending = (p || fetchCart()).then(reconcile).then(loadCompare).then(function (c) { render(c); return c; });
    return pending;
  }

  function linesHTML(cart, fallback) {
    return cart.items.map(function (it, i) {
      if (isProtection(it)) return '';
      var line = i + 1;
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : fallback;
      var cmp = compareAt[String(it.variant_id)] || 0;
      var wasLine = cmp > it.final_price ? cmp * it.quantity : 0;
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cl__variant">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="cl">' +
        (img ? '<img class="cl__img" src="' + esc(img) + '" alt="" width="80" height="80" loading="lazy">' : '<span class="cl__img"></span>') +
        '<div class="cl__main">' +
          '<div class="cl__top"><a class="cl__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          '<button type="button" class="cl__rm" data-qty="' + line + '" data-q="0" aria-label="הסרת המוצר">' + TRASH + '</button></div>' +
          variant +
          '<div class="cl__bottom">' +
            '<div class="cl__qty"><button type="button" data-qty="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="הפחתת יחידה">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-qty="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="הוספת יחידה">+</button></div>' +
            '<div class="cl__price">' + (wasLine ? moneyTag(wasLine, 's') : '') + moneyTag(it.final_line_price, 'strong') + '</div>' +
          '</div>' +
        '</div></div>';
    }).join('');
  }

  function render(cart) {
    var others = cart.items.filter(function (it) { return !isProtection(it); });
    var count = others.reduce(function (s, it) { return s + it.quantity; }, 0);
    var hasProtection = cart.items.some(isProtection);
    var inCart = cart.items.map(function (it) { return String(it.variant_id); });
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
    $$('[data-drawer-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });

    panels.forEach(function (panel) {
      var box = $('[data-cart-lines]', panel);
      box.innerHTML = others.length ? linesHTML(cart, panel.getAttribute('data-fallback-img') || '')
        : '<div class="drawer__empty"><p>העגלה שלך ריקה</p><a class="btn" href="' + root + '/products/brightrest-pillow">לקנייה</a></div>';
      $('[data-cart-total]', panel).textContent = money(cart.total_price);
      var tg = $('[data-protection-toggle]', panel);
      if (tg) { tg.checked = hasProtection; tg.disabled = false; }
      $$('[data-upsell-variant]', panel).forEach(function (u) { u.hidden = inCart.indexOf(u.getAttribute('data-upsell-variant')) > -1; });
      var ups = $('[data-upsells]', panel);
      if (ups) ups.hidden = !others.length || !$$('[data-upsell-variant]:not([hidden])', panel).length;
      var foot = $('.drawer__foot', panel); if (foot) foot.hidden = !others.length;
      var bar = $('[data-ship-bar]', panel);
      if (bar) {
        var th = +bar.getAttribute('data-threshold'); var left = th - cart.total_price;
        $('[data-ship-text]', bar).textContent = left > 0 ? 'עוד ' + money(left) + ' למשלוח חינם' : 'מגיע לכם משלוח חינם!';
        $('[data-ship-fill]', bar).style.width = Math.min(100, cart.total_price / th * 100) + '%';
      }
    });
  }

  function openCart() {
    return refresh().then(function () {
      if (!drawerHasPanel) { window.location.href = T.cartUrl; return; }
      lastFocus = document.activeElement;
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var f = $('[data-drawer-close].icon-btn', drawer); f && f.focus();
    });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); var m = $('#MobileNav'); m && m.classList.remove('is-open'); } });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]') && drawerHasPanel) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-drawer-close]')) closeCart();
    var co = e.target.closest('[data-checkout]');
    if (co) {
      /* make sure the protection toggle has been saved before leaving for checkout */
      e.preventDefault();
      co.setAttribute('aria-busy', 'true');
      var go = function () { window.location.href = co.getAttribute('href') || '/checkout'; };
      pending.then(go, go);
      return;
    }
    var q = e.target.closest('[data-qty]');
    if (q) {
      q.disabled = true;
      refresh(postJSON('/cart/change.js', { line: +q.getAttribute('data-qty'), quantity: Math.max(0, +q.getAttribute('data-q')) }));
    }
    var up = e.target.closest('[data-add-upsell]');
    if (up) {
      up.disabled = true;
      postJSON('/cart/add.js', { items: [{ id: +up.getAttribute('data-add-upsell'), quantity: 1 }] })
        .then(function () { return refresh(); })
        .finally(function () { up.disabled = false; });
    }
  });
  document.addEventListener('change', function (e) {
    var tg = e.target.closest('[data-protection-toggle]');
    if (!tg || !PV) return;
    var on = tg.checked;
    setProtectionPref(on);
    $$('[data-protection-toggle]').forEach(function (t) { t.checked = on; t.disabled = true; });
    var updates = {}; updates[PV] = on ? 1 : 0;
    refresh(postJSON('/cart/update.js', { updates: updates }));
  });
  if (panels.length) refresh().catch(function () {});
})();